module.exports = __webpack_public_path__ + "img/TECH_Horizontal_White.0a893a33.png";